import React, { useState } from 'react';
import '../../../../../../../Stylesheets/Dashboard/Tabs/Labor/PaymentHistoryTable.css';
import PaymentHistoryModal from './PaymentHistoryModal'; // Import modal
import { format } from 'date-fns';

const PaymentHistoryTable = ({ payments = [] }) => {
  const [showModal, setShowModal] = useState(false);

  const recentPayments = payments.slice(0, 5);

  return (
    <>
      <div className="worker-drawer-payment-history">
        <div className="worker-drawer-payment-header">
          <h4>Payment History</h4>
          <span className="worker-drawer-payment-sub">(Latest Transactions)</span>
        </div>

        <div className="worker-drawer-payment-table-wrapper">
          <table className="worker-drawer-payment-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Amount</th>
                <th>Mode</th>
                <th>Note</th>
                <th>Receipt</th>
              </tr>
            </thead>
            <tbody>
              {recentPayments.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center', padding: '16px' }}>No payments available</td>
                </tr>
              ) : (
                recentPayments.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.date ? format(new Date(row.date), 'dd MMM yyyy') : '—'}</td>
                    <td><strong>₹ {row.amount}</strong></td>
                    <td>{row.mode}</td>
                    <td>{row.note || '—'}</td>
                    <td>
                      {row.receiptUrl ? (
                        <a
                          href={row.receiptUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="worker-drawer-receipt-link"
                          title={row.receiptName || 'Receipt'}
                        >
                          View
                        </a>
                      ) : '—'}
                    </td>

                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {payments.length > 5 && (
          <button className="worker-drawer-payment-btn" onClick={() => setShowModal(true)}>
            See All Payment Logs
          </button>
        )}
      </div>

      {/* Modal */}
      {showModal && (
        <PaymentHistoryModal payments={payments} onClose={() => setShowModal(false)} />
      )}
    </>
  );
};

export default PaymentHistoryTable;
